import { defineStore } from 'pinia';
import { computed } from 'vue';
import { IntercomJournalSurveyIds } from 'Components/journals/constants';

export const useJournalsStore = defineStore('journals', () => {
    const intercomJournalSurveyId = computed(() => {
        switch (Lang.locale()) {
            case 'da':
                return IntercomJournalSurveyIds.Danish;
            case 'no':
                return IntercomJournalSurveyIds.Norwegian;
            case 'se':
                return IntercomJournalSurveyIds.Swedish;
            case 'fi':
                return IntercomJournalSurveyIds.Finnish;
            default:
                return IntercomJournalSurveyIds.English;
        }
    });

    return { intercomJournalSurveyId };
});
